exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-control.custom-radio[data-v-79f417f8]{\n\tpadding-left: 0 !important;\n}\n.custom-control.custom-radio input[data-v-79f417f8]{\n\tpadding-right: 5px !important;\n}\n", ""]);

// exports
